import { Cart, UpdateCartInput } from '@shop/models/src/cart';
import client from './base';

export const getCart = async () => client.base.get<Cart>('/v1/cart');

export const updateCart = async (body: UpdateCartInput) =>
  client.base.put<Cart>('/v1/cart', { body: JSON.stringify(body) });
